import React from 'react';

const Footer = () => (
  <footer className="footer bg-primary text-white text-center py-4 mt-5">
    <div className="container">
      <p className="mb-2">Bimbel Stema Kupang &copy; {new Date().getFullYear()} | All Rights Reserved</p>
      <div>
        <a href="https://wa.me/6282117519556" className="text-white me-3"><i className="bi bi-whatsapp"></i></a>
        <a href="https://instagram.com" className="text-white me-3"><i className="bi bi-instagram"></i></a>
        <a href="https://facebook.com" className="text-white"><i className="bi bi-facebook"></i></a>
      </div>
    </div>
  </footer>
);

export default Footer;
